import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'

export interface IGettingStartedModuleStatus {
  dismissed: boolean;
}

export function gettingStartedModuleApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/getting-started-module'
  const methods = {
    getGettingStartedModuleStatus() {
      return api.get<IGettingStartedModuleStatus>(baseUrl)
    },
    dismissGettingStartedModuleStatus() {
      return api.post<IGettingStartedModuleStatus>(baseUrl)
    }
  }
  return createOptimizedAPI(methods)
}
